/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ServicePrivate from "../../../services/ServicePrivate";
import ApiBack from "../../../utils/domains/ApiBack";
import { useNavigate } from "react-router-dom";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { ToastContainer } from "react-toastify";
import IPS from "../../../models/Ips";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import logo from "../../../assets/images/Rocky/logoRockyPre.png";
import signature from "../../../assets/images/Rocky/firmaDoctor.jpeg";
import SupportViewFinally from "../../../models/supportViewFinally";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DateFilterButtons from "../../component/DateFilterButtons";
import AuthorizedDevice from "../../../models/AuthorizedDevice";
import { DoorClosed } from 'lucide-react';
import News from "../../../models/News";

export const ListAllNews = () => {
    const [arrayAllNews, setArrayAllNews] = useState<News[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [startDateEntry, setStartDateEntry] = useState<string>("");
    const [endDateEntry, setEndDateEntry] = useState<string>("");

    const [selectedType, setselectedType] = useState<string>("");
    const [selectedIpsName, setselectedIpsName] = useState<string>("");
    const [page, setPage] = useState(1);
    const [pageConcate, setPageConcate] = useState(1);
    const [limit, setlimit] = useState(0);
    const [limitConcate, setlimitConcate] = useState(0);
    const [Total, setTotal] = useState(0);
    const [typeCondensate, setTypeCondensate] = useState("");
    const [pageNext, setPagenext] = useState(0);
    const [pageprevious, setPageprevious] = useState(0);
    const [expandedRow] = useState(null);
    const [show, setShow] = useState<boolean>(false);
    const [isSearchTriggered, setIsSearchTriggered] = useState(false);

    const [selectedDevice, setSelectedDevice] = useState<AuthorizedDevice>(
        new AuthorizedDevice(
            0,
            "",
            "",
            false,
            false,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            ""
        )
    );

    const handleClose = () => setShow(false);

    const handlePreviousPage = () => {
        if (page > 1) {
            setPage(page - 1);
            getAllNews(page - 1); // Llama a la API con la página anterior
        }
    };


    const handleNextPage = () => {
        if (page < limit) {
            setPage(page + 1);
            getAllNews(page + 1); // Llama a la API con la página siguiente
        }
    };


    //Get to all support, but filter with values to selected for the users
    const getAllNews = async (page: number) => {
        setLoading(true);
        try {
            const url = `${ApiBack.ALL_NEWS}?${[
                selectedType ? `id_type_request_id=${selectedType}` : "",
                selectedIpsName ? `ipsName=${selectedIpsName}` : "",
                startDateEntry ? `startDateEntry=${startDateEntry}` : "",
                endDateEntry ? `endDateEntry=${endDateEntry}` : "",
                page ? `page=${page}` : "",
            ]
                .filter(Boolean)
                .join("&")}`;

            if (
                (startDateEntry != "" && endDateEntry == "") ||
                (startDateEntry == "" && endDateEntry != "")
            ) {
                MessageToastify(
                    "error",
                    "Debes seleccionar las fechas de inicio y de fin para filtrar por rango de fechas.",
                    4000
                );
                setLoading(false);
                return;
            }

            try {
                const response = await ServicePrivate.requestGET(url);
                if (response.length == 0) {
                    MessageToastify(
                        "info",
                        "No se encontraron resultados para los filtros seleccionados.",
                        4000
                    );
                    setArrayAllNews([]);
                    return;
                }
                if (response.results && Array.isArray(response.results)) {
                    setArrayAllNews(response.results);
                    setlimit(response.total_pages);
                    setTotal(response.total);
                    setPagenext(response.next);
                    setPageprevious(response.previous);
                    setLoading(false);
                    console.log(response);
                    
                } else {
                    console.error("La respuesta no es un array:", response);
                    MessageToastify("info", response.error, 4000);
                    setArrayAllNews([]);
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
                MessageToastify("info", "No se encuentran resultados.", 2000);
                setArrayAllNews([]);
                setlimit(0);
                setTotal(0);
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching supports:", error);
            const token = localStorage.getItem("access");
            if (!token) handleTokenError();
        } finally {
            setLoading(false);
        }
    };

    const getDeviceById = async (device_id: number) => {
        try {
            const url = `${ApiBack.DEVICE_BY_ID}/${device_id}`;
            const results = await ServicePrivate.requestGET(url);
            console.log(results);

            setSelectedDevice(results.results);
            console.log(selectedDevice);
            setLoading(false);
        } catch (error) {
            console.error("Error en el servidor:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };

    const handleShow = (divice_id: number) => {
        getDeviceById(divice_id);
        setShow(true);
    };

    const device_update = async (device_id: number) => {
        try {
            const url = `${ApiBack.DEVICE_INACTIVATE}/${device_id}`;
            const results = await ServicePrivate.requestPUT(url, selectedDevice);
            console.log(results);
            if (results.status === 200) {
                MessageToastify("success", results.data.mensaje, 2000);
                setShow(false);
                getAllNews(page);
            } if (results.status === 500) {
                MessageToastify("error", results.data.mensaje, 2000);
            }
        }
        catch (error: any) {
            if (error.status === 500) {
                MessageToastify("error", error || "Error en el servidor", 4000);
            } else {
                MessageToastify("error", "Error de conexión con el servidor", 4000);
            }
        }
    }

    const handleTokenError = () => {
        navigate("/"); // Go to login session
    };

    const handleIpsNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedIpsName(event.target.value);
    };

    const truncateText = (text: string, maxLength: any) =>
        text?.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    useEffect(() => {
        //getSupport(page);
        MessageToastify(
            "info",
            "Recuerde ingresar el filtro para ver los datos.",
            2000
        );
        setLoading(true);
        const today = new Date();
        const firstDayMonth = new Date(
            today.getFullYear(),
            today.getMonth(),
            1
        );
        const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        // Formatear la fecha en YYYY-MM-DD
        const formatDate = (date: Date) => date.toISOString().split("T")[0];

        setStartDateEntry(formatDate(firstDayMonth));
        setEndDateEntry(formatDate(lastDayLastMonth));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {
    setLoading(false);
        if ( startDateEntry && endDateEntry) {
            getAllNews(page);
            setIsSearchTriggered(false); // Resetear para futuras búsquedas
        }
    }, [startDateEntry, endDateEntry, page, isSearchTriggered]);


    return (
        <>
            <div>
                <div className="row align-items-center">
                    <div className="col-lg-12 col-sm-12 d-flex justify-content-center">
                        <h3 style={{ fontWeight: "bold" }}>Todas las noticias</h3>
                    </div>

                    <div className="col-lg-12 col-sm-12 d-flex justify-content-center">
                        <div className="row">
                            <div className="d-flex align-items-center col-lg-8 col-md-12">
                                <Form.Group className="" controlId="startDateEntry">
                                    <Form.Label className="fw-bold">Fecha de inicio</Form.Label>
                                    <Form.Control
                                        required
                                        type="date"
                                        // id="startDateEntry"
                                        value={startDateEntry}
                                        onChange={(e) => setStartDateEntry(e.target.value)}
                                        onClick={() => {
                                            setArrayAllNews([]);
                                            setPage(0);
                                            setlimit(0);
                                            setTotal(0);
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group className="" controlId="startDateEntry">
                                    <Form.Label className="fw-bold">Fecha de fin</Form.Label>
                                    <Form.Control
                                        required
                                        type="date"
                                        value={endDateEntry}
                                        onChange={(e) => setEndDateEntry(e.target.value)}
                                        onClick={() => {
                                            setArrayAllNews([]);
                                            setPage(0);
                                            setlimit(0);
                                            setTotal(0);
                                        }}
                                    />
                                </Form.Group>
                            </div>
                            <div className="d-flex align-items-center mt-lg-4 col-lg-4 col-md-12 mb-3">
                                      <Button className="ms-2 mt-3 badge fs-6 p-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill"
                                        variant="primary" onClick={() => getAllNews(page)}>
                                        <i className="fa-solid fa-magnifying-glass"></i>&nbsp;Buscar
                                      </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="fs-6 fw-light">
                                    <div className="row d-flex">
                                        <div className="col-lg-2 col-md-4 col-sm-4 align-content-center">
                                            <p>
                                                Equipos encontrados:&nbsp;
                                                <b className="fw-bold">{arrayAllNews?.length}</b>
                                            </p>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-3 align-content-center">
                                            <p>
                                                Equipos totales:&nbsp;
                                                <b className="fw-bold">{Total}</b>
                                            </p>
                                        </div>
                                        <div className="col-lg-2 col-md-4 col-sm-3 align-content-center">
                                            <p>
                                                Páginas totales:&nbsp;
                                                <b className="fw-bold">{limit}</b>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-striped table-sm rounded-table">
                                        <thead className="table-dark">
                                            <tr>
                                                <th scope="col" style={{ width: "20%" }}>
                                                    Titulo
                                                </th>
                                                <th scope="col" style={{ width: "50%" }}>
                                                    Descripción
                                                </th>
                                                <th scope="col" style={{ width: "15%" }}>
                                                    url
                                                </th>
                                                <th scope="col" style={{ width: "10%" }}>
                                                    Fecha de creación
                                                </th>
                                                <th scope="col" style={{ width: "5%" }}>
                                                    Estado de la noticia
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <>
                                                    <tr>
                                                        <td colSpan={12} className="text-center">
                                                            <div className="d-flex flex-column align-items-center">
                                                                <div
                                                                    className="spinner-border"
                                                                    role="status"
                                                                    style={{
                                                                        width: "3rem",
                                                                        height: "3rem",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    <span className="visually-hidden">
                                                                        Cargando...
                                                                    </span>
                                                                </div>
                                                                <p
                                                                    className="mt-3 fs-5"
                                                                    style={{ color: "#000" }}
                                                                >
                                                                    Cargando datos, por favor espere...
                                                                </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <>
                                                    {arrayAllNews?.length === 0 && (
                                                        <tr>
                                                            <td colSpan={12} className="text-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                    <p
                                                                        className="mt-3 fs-5"
                                                                        style={{ color: "#000" }}
                                                                    >
                                                                        No tiene noticias en el momento de buscar.
                                                                    </p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {arrayAllNews.map((myNews, count) => (
                                                        <tr key={count + 1}>
                                                            <td>
                                                                <span
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title={myNews?.title} // Este es el texto que se mostrará en el tooltip
                                                                >
                                                                    {
                                                                        truncateText(myNews.title,30)
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title={myNews?.content} // Este es el texto que se mostrará en el tooltip
                                                                >
                                                                    {
                                                                        truncateText(myNews.content, 100)
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title={myNews?.url} // Este es el texto que se mostrará en el tooltip
                                                                >
                                                                    {
                                                                        truncateText(myNews.url, 20)
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {new Date(
                                                                    myNews.created_at
                                                                ).toLocaleString("es-CO", {
                                                                    year: "numeric",
                                                                    month: "2-digit",
                                                                    day: "2-digit",
                                                                })}
                                                            </td>

                                                            <td className="d-none d-md-table-cell">
                                                                {myNews.is_active === true ? (<>
                                                                    <button
                                                                        className={`badge fs-6 py-1 pe-3 border rounded-pill w-60 
                                        ${myNews.is_active
                                                                                ? "text-danger-emphasis bg-danger-subtle border-danger-subtle"
                                                                                : "text-danger-emphasis bg-danger-subtle border-danger-subtle"}`}
                                                                        type="button"
                                                                        onClick={() => device_update(myNews.id)}
                                                                    >
                                                                        {localStorage.getItem("role") === "ADMINISTRADOR" ? (<>{myNews.is_active ? (
                                                                            <>
                                                                                <i className="fa-regular fa-circle-xmark"></i>
                                                                                &nbsp;Inactivar
                                                                            </>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}</>) : (<></>)}

                                                                    </button></>) : (<></>)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex align-items-center justify-content-center">
                                    <nav className="inline-flex space-x-2.5 justify-content-center">
                                        <button
                                            className="badge fs-6 p-2 pe-2 px-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill"
                                            onClick={handlePreviousPage}
                                            disabled={page === 1}
                                        >
                                            <i className="fa-solid fa-arrow-left"></i>
                                            &nbsp;Anterior
                                        </button>
                                        &nbsp;
                                        <span className="fs-6">
                                            Página {page} de {limit}
                                        </span>
                                        &nbsp;
                                        <button
                                            className="badge fs-6 p-2 pe-2 px-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill "
                                            onClick={handleNextPage}
                                            disabled={page === limit}
                                        >
                                            Siguiente&nbsp;
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </button>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        {/* Modal para eliminar */}
                        {/* *********************************************************************************/}
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title><i className="fa-solid fa-lock"></i>&nbsp;Clave del dispositivo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedDevice && (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <p >
                                <strong >Clave del dispositivo:</strong>&nbsp;
                                {selectedDevice.use_key === null ? selectedDevice.key : "Clave de uso."}
                                <Button
                                    className="badge bg-success-subtle text-success-emphasis rounded-pill ms-2"
                                    size="sm"
                                    disabled={selectedDevice.use_key !== null}
                                    onClick={() => {
                                        if (selectedDevice.use_key === null) {
                                            navigator.clipboard.writeText(selectedDevice.key);
                                            MessageToastify("success", "Clave copiada al portapapeles.", 2000);
                                        }
                                    }}
                                >
                                    <i className="fa-solid fa-copy"></i>
                                </Button>
                            </p>
                            &nbsp;
                            <p >
                                <strong>Clave del uso:</strong>&nbsp;
                                {selectedDevice.use_key === null ? selectedDevice.password_divice : "Clave de uso."}
                                <Button
                                    className="badge bg-success-subtle text-success-emphasis rounded-pill ms-2"
                                    size="sm"
                                    disabled={selectedDevice.use_key !== null}
                                    onClick={() => {
                                        if (selectedDevice.use_key === null) {
                                            navigator.clipboard.writeText(selectedDevice.key);
                                            MessageToastify("success", "Clave copiada al portapapeles.", 2000);
                                        }
                                    }}
                                >
                                    <i className="fa-solid fa-copy"></i>
                                </Button>
                            </p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        <DoorClosed />&nbsp;Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer />
        </>
    );
};
